import { connect } from 'react-redux';
import _ from 'lodash';
import PipedriveView from './PipedriveView.jsx';
import { getIntegrationForType, fetchIntegrations } from 'src/legacy/redux/actions/integrations.jsx';
import { authenticateAccount } from 'src/legacy/redux/actions/integrations/pipedrive.jsx';  
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';
import {trackAdoptionMetricsForPluginConnectedEvent} from "src/legacy/redux/actions/adoption";

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'pipedrive');
  return {
    integration: integration,
    integrations: state.legacyRootReducer.settings.integrations,
    deactivating: state.legacyRootReducer.settings.integrations.activated.deactivating.loading,
    user: _.get(state, 'users.me',""),
    integrationsLoading: _.get(state.legacyRootReducer.settings.integrations, 'activated.loading' ,false)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authenticateAccount: (code) => {
      return dispatch(authenticateAccount(code));
    },

    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    },
    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName))
    }
  }
}

const PipedrivePage = connect (
    mapStateToProps,
    mapDispatchToProps
)(PipedriveView);

export default withUseHooks(PipedrivePage);
